import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";

import { store, persistor } from "../states/store";
// import { userActions } from "../states/ducks";
import { AppRouter } from "./routes";
import "app/views/assets/scss/style.scss";

const App: React.FC = () => {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRouter />
        <ToastContainer
          autoClose={1000}
        />

      </PersistGate>
    </Provider>
  );
};

export default App;
